export default function HowHarambeeWorks() {
  return (
    <section className="py-24 px-6 bg-[#1A4D3C] relative overflow-hidden">
      {/* Subtle pattern */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            How We Work
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            A Phased, Relationship-Driven Model
          </h2>
          <p className="text-white/65 text-base leading-relaxed">
            We don&apos;t rush the process. Our advisory model is built on trust, education, and a clear progression that respects where each client is in their journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {[
            {
              phase: "Phase 01",
              icon: "ri-book-open-line",
              title: "Education & Trust-Building",
              desc: "Every advisory relationship begins with education. We help clients build the financial literacy and market awareness needed to engage with opportunities confidently and responsibly.",
              items: ["Financial literacy foundation", "Market awareness sessions", "Goal clarification conversations", "No-pressure introductory engagement"],
            },
            {
              phase: "Phase 02",
              icon: "ri-discuss-line",
              title: "Structured Advisory Conversations",
              desc: "Once a foundation is established, we move into structured advisory conversations &mdash; exploring your goals, readiness, and the pathways most aligned with your long-term vision.",
              items: ["Investor readiness assessment", "Cross-border opportunity mapping", "Strategic planning sessions", "Relationship and network development"],
            },
            {
              phase: "Phase 03",
              icon: "ri-arrow-up-circle-line",
              title: "Advanced Pathways & Opportunities",
              desc: "For qualified clients, we provide guidance toward family office support, private credit considerations, and co-investment opportunities within our trusted network.",
              items: ["Family office structure guidance", "Private credit advisory", "Co-investment pathway support", "Long-term wealth strategy development"],
            },
          ].map((phase, i) => (
            <div
              key={phase.phase}
              className="bg-white/8 border border-white/15 rounded-lg p-8 hover:bg-white/12 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/20">
                  <i className={`${phase.icon} text-[#C9A961] text-xl`} />
                </div>
                <span className="text-[#C9A961]/50 text-xs font-semibold uppercase tracking-widest">
                  {phase.phase}
                </span>
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-3 leading-snug">
                {phase.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed mb-6">{phase.desc}</p>
              <ul className="space-y-2">
                {phase.items.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#C9A961] text-sm" />
                    </div>
                    <span className="text-white/70 text-xs">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom disclaimer */}
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-start gap-3 bg-white/8 border border-white/15 rounded-lg px-6 py-4">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#C9A961] text-base" />
            </div>
            <p className="text-white/55 text-xs leading-relaxed text-left">
              Harambee Global Ventures provides educational and advisory services only. We do not manage client funds, offer personalized investment advice, or make guarantees about financial outcomes. All investment decisions remain the responsibility of the individual client.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
